import React, { FC, PropsWithChildren, SyntheticEvent } from 'react';
import LaddaButton, { SLIDE_LEFT } from 'react-ladda';
import { observer } from 'mobx-react';
import classNames, { Argument as ClassValue } from 'classnames';
import { useFormikContext } from 'formik';
import isEqual from 'lodash/isEqual';

interface ISaveButton {
  className?: ClassValue;
  onClick?: (e: SyntheticEvent) => void;
}

export const SaveButton: FC<ISaveButton> = observer((props: PropsWithChildren<ISaveButton>) => {
  const { className, children, onClick } = props;
  const { isSubmitting, submitForm, initialValues, values, isValid } = useFormikContext();

  return (
    <>
      <LaddaButton
        disabled={isEqual(initialValues, values) || !isValid}
        type="submit"
        onClick={(e: SyntheticEvent) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          submitForm();

          if (onClick) {
            onClick(e);
          }
        }}
        data-style={SLIDE_LEFT}
        className={classNames('btn btn-primary', className)}>
        {children || 'Сохранить'}
      </LaddaButton>
      <div style={{ display: 'none' }}>
        <button type="submit" id="sbBtn" />
      </div>
    </>
  );
});
